
import {Component, Prop, Vue} from 'vue-property-decorator';
import {readAdminForms, readAdminRoles, readDefaultRoleSettings} from '@/store/admin/getters';
import {dispatchGetDefaultRoleSetting, dispatchGetFormsAdmin} from '@/store/admin/actions';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import {IRoleSettings} from '@/interfaces/role';
import ImportRoleSettings from '@/components/dialogs/ImportRoleSettings.vue';

@Component({
  components: {ImportRoleSettings, DefaultHelp},
})
export default class RoleSettings extends Vue {
  @Prop() public settingsProp!: IRoleSettings;
  @Prop() public cannotEditSettings!: boolean;

  public async mounted() {
    if (!this.defaultSettings) {
      await dispatchGetDefaultRoleSetting(this.$store);
    }

    if (!this.forms) {
      await dispatchGetFormsAdmin(this.$store);
    }



    if (!this.settingsProp) {
      this.settings = this.defaultSettings as unknown as IRoleSettings;
    }
  }

  private get settings() {
    return this.settingsProp;
  }

  private set settings(val) {
    this.$emit('change-settings', val);
  }

  public importFunction(val) {
    if (val && val instanceof Object) {
      this.settings = {...val?.settings} as unknown as IRoleSettings;
    }
  }

  private get defaultSettings() {
    return readDefaultRoleSettings(this.$store);
  }

  private get forms() {
    return readAdminForms(this.$store);
  }

  private get roles() {
    return readAdminRoles(this.$store);
  }

  private addFunction() {
    // @ts-ignore
    this.settings?.custom_data?.push({name: '', value: ''});
  }

  private deleteFunction(val) {
    this.settings?.custom_data?.splice(val, 1);
  }

  private get likesAllForms() {
    return this.settings.forms_enabled?.length === this.forms?.length;
  }

  private get likesSomeForm() {
    return this.settings.forms_enabled?.length > 0 && !this.likesAllForms;
  }


  private get icon() {
    if (this.likesAllForms) {
      return 'mdi-close-box';
    }
    if (this.likesSomeForm) {
      return 'mdi-minus-box';
    }
    return 'mdi-checkbox-blank-outline';
  }

  private toggle() {
    this.$nextTick(() => {
      if (this.likesAllForms) {
        this.settings.forms_enabled = [];
      } else {
        this.settings.forms_enabled = this.forms.slice() as unknown as [];
      }
    });
  }

}
